import { combineReducers } from 'redux';

import {
  getArtists,
  getConcert,
  getPastConcerts,
  getConcerts,
  getHome,
  getPress,
  getNews,
  getNewsListing,
  getAboutData,
  getFAQ,
  getUsefulContacts,
  getSponsors,
  getContactData,
  getDonationData,
  getPressFormData,
  getPressInner,
  getSearchResults,
  getSettingsData,
  getMeta
} from './users.reducer';

const rootReducer = combineReducers({
  getMeta,
  getHome,
  getPastConcerts,
  getConcerts,
  getConcert,
  getArtists,
  getPress,
  getNews,
  getNewsListing,
  getAboutData,
  getFAQ,
  getUsefulContacts,
  getSponsors,
  getContactData,
  getDonationData,
  getPressFormData,
  getPressInner,
  getSearchResults,
  getSettingsData,
});

export default rootReducer;
